import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const infoName: SxStyle = {
  color: (p) => p.palette.grey[700],
  textAlign: 'left',
};

export const infoEmail: SxStyle = {
  color: (p) => p.palette.grey[500],
  textAlign: 'left',
};

export const infoAvatar: SxStyleFunc<{ isCurrentUser: boolean }> = ({
  isCurrentUser,
}) => ({
  borderRadius: '100%',
  border: (p) =>
    `4px solid ${isCurrentUser ? p.palette.primary[100] : p.palette.grey[200]}`,
});
